import cn from 'classnames';
import React from 'react';

import { crc32 } from '../../utils/crc32';

import { LOADER_ICON_COLOR_VARS, LOADER_ICON_SIZE } from './Loader.constants';
import styles from './Loader.module.scss';
import { LoaderColors, LoaderProps, LoaderSizes } from './Loader.types';

/**
 * Loader
 */
export const Loader = (props: LoaderProps) => {
  const className = (props as { className?: string }).className;
  const {
    size = LoaderSizes.m,
    inline = false,
    loaderInsideButton = false,
    noMargin = false,
    color = LoaderColors.brand,
  } = props;

  const [gradientIdStart, gradientIdEnd] = React.useMemo<[string, string]>(
    () => [`loader-gradient-${crc32('loader-start')}`, `loader-gradient-${crc32('loader-end')}`],
    [],
  );
  const loaderClassName = cn(
    styles.loader,
    {
      [styles[`loader_size_${size}`]]: size,
      [styles.inline]: inline,
      [styles.loaderInsideButton]: loaderInsideButton,
      [styles.noMargin]: noMargin,
    },
    className,
  );

  return (
    <div {...props} className={loaderClassName}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 34 34'
        fill='none'
        width={LOADER_ICON_SIZE[size]}
        height={LOADER_ICON_SIZE[size]}
        color={LOADER_ICON_COLOR_VARS[color]}
      >
        <g strokeWidth='2'>
          <path stroke='currentColor' strokeLinecap='round' d='M 30 17 A 13 13 0 0 1 30 16' />
          <path stroke={`url(#${gradientIdStart})`} d='M 4 17 A 13 13 0 0 1 30 17' />
          <path stroke={`url(#${gradientIdEnd})`} d='M 30 17 A 13 13 0 0 1 4 17' />
        </g>
        <defs>
          <linearGradient id={gradientIdStart}>
            <stop offset='0%' stopOpacity='0.5' stopColor='currentColor' />
            <stop offset='100%' stopOpacity='1' stopColor='currentColor' />
          </linearGradient>
          <linearGradient id={gradientIdEnd}>
            <stop offset='0%' stopOpacity='0.5' stopColor='currentColor' />
            <stop offset='100%' stopOpacity='0' stopColor='currentColor' />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};
